<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-data-table
    :headers="getFactoringsHeaders ()"
    :items="getItems ()"
    :loading="factoringsLoading"
    :items-per-page="rowsPerPage"
    :total-items="rowCount"
    :no-data-text="$t('krita.datagrid.nodata')"
    hide-actions
  >
    <template v-slot:headers="props">
      <data-grid-sort
        :props="props"
        :pagination="pagination"
        @changeSort="changeSort"
      />
    </template>
    <template v-slot:items="props">
      <tr @click="navigateToFactoringDetail(props.item.id)">
        <td><router-link 
          :to="{name: 'Factoring detail', params: {id: props.item.id}}" 
          target="_self">{{ props.item.id }}</router-link></td>
        <td>{{ props.item.debtorName }} ehf (kt. {{ props.item.debtorRegistryId | kennitala }})</td>
        <td>{{ props.item.status }}</td>
        <td>{{ props.item.factoringDueDate | date }}</td>
        <td>{{ props.item.amount | amount }}</td>
        <td>{{ props.item.leftToPay | amount }}</td>
        <!--<td>{{ props.item.debtorRegistryId }}</td>-->
        <td>{{ props.item.account | account }}</td>
        <td>{{ props.item.initialTransferAmount | amount }}</td>
        <td>{{ props.item.created | date }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import DataGridSort from '../../controllers/DataGridSort'
import EnumIterator from '../../helper/EnumIterator';
export default {
    components: {DataGridSort},
    props: ['factoringReportData','factoringsLoading','rowCount','rowsPerPage'],
    data () {
        return {
            pagination:
                {
                    sortBy: 'id'
                },
            items: []
        }
    },
    methods: {
        getFactoringsHeaders ()
        {
            return [
                {sortable: true, text: this.$t('krita.reports.factorings.header.id'), value: 'id', type: 'int', align: 'left'},
                {sortable: true, text: this.$t('krita.reports.factorings.header.debtorinfo'), value: 'debtor', type: 'string', align: 'left'},
                {sortable: true, text: this.$t('krita.reports.factorings.header.status'), value: 'status', type: 'int', align: 'left'},
                {sortable: true, text: this.$t('krita.reports.factorings.header.factoringduedate'), value: 'factoringDueDate', type: 'date', align: 'left'},
                {sortable: true, text: this.$t('krita.reports.factorings.header.capital'), value: 'amount', type: 'int', align: 'left'},
                {sortable: false, text: this.$t('krita.reports.factorings.header.lefttopay'), value: 'leftToPay', type: 'int', align: 'left'},
                {sortable: true, text: this.$t('krita.reports.factorings.header.account'), value: 'account', type: 'int', align: 'left'},
                {sortable: true, text: this.$t('krita.reports.factorings.header.initialtransferamount'), value: 'initialTransferAmount', type: 'int', align: 'left'},
                {sortable: true, text: this.$t('krita.reports.factorings.header.created'), value: 'created', type: 'date', align: 'left'},
            ]
        },
        getItems ()
        {
          let self = this;

          let items = [];
          for (let factoringReport of self.factoringReportData)
          {
            let factoringReportClient = {
              id: factoringReport.id,
              status: self.$t(EnumIterator.processFactoringStatus(factoringReport.status)),
              leftToPay: factoringReport.leftToPay,
              debtorName: factoringReport.debtorName,
              debtorRegistryId: factoringReport.debtorRegistryId,
              factoringDueDate: factoringReport.factoringDueDate,
              amount: factoringReport.amount,
              initialTransferAmount: factoringReport.initialTransferAmount,
              created: factoringReport.created,
              account: factoringReport.account
            };
            items.push(factoringReportClient);
          }
          return items;
        },
        navigateToFactoringDetail (id)
        {
            let self = this;

            self.$router.push('/factoring/' + id);
        },
        changeSort (sort)
        {
            let self = this;

            self.pagination.sortBy = sort.sortBy;
            self.pagination.descending = sort.descending;
            self.$emit('refreshWithSort',self.pagination);
        }
    }
}
</script>
